import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Card, CardBody } from 'reactstrap'

import { immigrateFAQEntriesList } from 'features/immigrate/store'
import { NoDataTextMessage, DataShower } from 'components/Elements'
import { CategoryAdd } from './CategoryAdd'
import { PageHeader } from 'components/Layouts'
import { Sections } from './Section'

const FAQEntriesContainerComponent = ({ ...props }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(immigrateFAQEntriesList.cleanState({}))
    }
  }, [])

  useEffect(() => {
    fetchList()
  }, [props.page])

  const fetchList = () => {
    let params = {
      pagination: false,
      // sort: [{ id: 'created_at', desc: true }],
    }

    dispatch(immigrateFAQEntriesList.getList({ params }))
  }

  const isLoading = useMemo(() => {
    return props.loading
  }, [props.loading])

  const onCategoryAddSuccess = data => {
    dispatch(immigrateFAQEntriesList.addItem({ ...data }))
  }

  const onCategoryEditSuccess = data => {
    dispatch(immigrateFAQEntriesList.updateListItem({ ...data }))
  }

  const onCategoryRemoveSuccess = data => {
    dispatch(immigrateFAQEntriesList.removeItem({ ...data }))
  }

  const onQuestionAddSuccess = (id, question) => {
    dispatch(immigrateFAQEntriesList.addQuestionItem({ id, question }))
  }

  const onQuestionEditSuccess = (id, question) => {
    dispatch(immigrateFAQEntriesList.updateQuestionItem({ id, question }))
  }

  const onQuestionRemoveSuccess = (id, question) => {
    dispatch(immigrateFAQEntriesList.removeQuestionItem({ id, question }))
  }

  return (
    <>
      <PageHeader headerRight={<CategoryAdd onSuccess={onCategoryAddSuccess} />} />

      <DataShower isLoading={isLoading} isFetched isFailed={!!props.error} error={props.error}>
        <Card>
          <CardBody>
            <Sections
              items={props.list}
              action
              addControlProps={{ onSuccess: onQuestionAddSuccess }}
              editControlProps={{ onSuccess: onCategoryEditSuccess }}
              removeControlProps={{ onSuccess: onCategoryRemoveSuccess }}
              onQuestionEditSuccess={onQuestionEditSuccess}
              onQuestionRemoveSuccess={onQuestionRemoveSuccess}
            />

            {!props.list.length && !props.loading && !props.error && (
              <NoDataTextMessage variant={'empty'} />
            )}
          </CardBody>
        </Card>
      </DataShower>
    </>
  )
}

FAQEntriesContainerComponent.propTypes = {}

const mapStateToProps = state => {
  const { list, loading, error, meta, page } = state.immigrate.faq.entries.list
  return {
    list,
    loading,
    error,
    meta,
    page,
  }
}

export const FAQEntriesContainer = connect(mapStateToProps)(FAQEntriesContainerComponent)
